module.exports = "pegasus/assets/blocks/column-11-theme6.png";